<!-- titulo -->
<ion-item mode="md" lines="none" color="gray" class="ion-text-center">
  <ion-label
    mode="md"
    color="status-icon-enable"
    class="create-new-password mpe-font-weight-600"
  >
    {{ "Titles.create-new-password" | translate }}
  </ion-label>
</ion-item>

<app-passwords-validator
  (newsPasswords)="invalidPassConfirm = $event"
  (newPassword)="newPassword = $event"
>
</app-passwords-validator>

<!-- Campos requeridos -->
<ion-item mode="md" lines="none" color="gray" class="ion-text-center">
  <ion-label mode="md" color="status-icon-enable" class="required-fields">
    <ion-text mode="md" color="danger">
      {{ "Forms.asterisk" | translate }}
    </ion-text>
    {{ "Labels.required-fields" | translate }}
  </ion-label>
</ion-item>

<!-- * Aceptar -->
<ion-item mode="md" lines="none" color="gray">
  <ion-button
    class="aceptar"
    color="darkblue"
    type="submit"
    [disabled]="invalidPassConfirm || spinner"
    (click)="newPass.next(newPassword)"
  >
    <ion-spinner name="crescent" slot="start" *ngIf="spinner"></ion-spinner>
    {{ "Buttons.save" | translate }}
  </ion-button>
</ion-item>
